module.exports = __webpack_public_path__ + "static/media/2_BDO_Logo.48573978.png";